import { create } from 'zustand';
import { ApiUtils, MiscApi, RequestStrategyEnum } from '@shared/api';

interface UseEconomicActivitiesStore {
  loading: boolean;
  data: string[];
  error: string | null;
  getEconomicActivities: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useEconomicActivitiesStore = create<UseEconomicActivitiesStore>((set) => ({
  loading: false,
  error: null,
  data: [],

  getEconomicActivities: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getEconomicActivities(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
